export default __webpack_public_path__ + "static/media/Diana-avanço-obras.2b548c01.png";